export default __webpack_public_path__ + "static/media/Menu_Hoodie_zip.6cda5891.svg";